import _ from 'lodash'

import Aeroplane from 'components/icons/Aeroplane'
import Boat from 'components/icons/Boat'
import Bus from 'components/icons/Bus'
import Train from 'components/icons/Train'
import Car from 'components/icons/Car'

export const travelTypes = {
  flight: {
    descr: 'Flight',
    icon: Aeroplane,
    direction: 'left-to-right',
  },
  boat: {
    descr: 'Boat',
    icon: Boat,
    direction: 'right-to-left',
  },
  bus: {
    descr: 'Bus',
    icon: Bus,
    direction: 'right-to-left',
  },
  train: {
    descr: 'Train',
    icon: Train,
    direction: 'left-to-right',
  },
  car: {
    descr: 'Car',
    icon: Car,
    direction: 'right-to-left',
  },
}

export const travelTypesList = []
let orderedTravelTypesList = []
Object.keys(travelTypes).forEach((type) => {
  orderedTravelTypesList.push({
    value: type,
    descr: travelTypes[type].descr,
  })
})
orderedTravelTypesList = _.orderBy(orderedTravelTypesList, 'descr')
travelTypesList.splice(0, 0, ...orderedTravelTypesList)

export const socialConfiguration = {
  shareTitle: 'Take a look at our trip on Tourplanr',
  hashtags: [
    'tourplanr',
  ],
  defaultDomain: 'https://tourplanr.com',
}



// WEBPACK FOOTER //
// ./src/core/index.js